import { gql } from '@apollo/client'
import { executeMutationSideload } from '@app/services/graphql/apolloClient'
import { EventChainItemInput } from './types'

const LOG_EVENT_CHAIN = gql`
  mutation LogEventChain($data: LogEventChainInput!) {
    eventChain {
      logEventChain(data: $data) {
        lastEventId
        count
      }
    }
  }
`

interface LogEventChainInput {
  tailId?: string | null
  spliceId?: string | null
  events: EventChainItemInput[]
}

interface LogEventChainResponse {
  lastEventId: string
  count: number
}

export const logEventChain = async (
  data: LogEventChainInput
): Promise<LogEventChainResponse> => {
  const result = await executeMutationSideload(LOG_EVENT_CHAIN, { data })
  return result?.eventChain?.logEventChain
}
